/**
 * Purges null values from an object.
 * @param {Object} obj - The object to purge null values from.
 * @returns {Object} - The object without null values.
 */

const purgeNullValues = (obj) => (
  Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null),
  )
);

export default purgeNullValues;
